import React, { Component, Fragment } from 'react';
import GenericExportContainer from '../Containers/GenericExport.container'
import { connect } from 'react-redux';
import { translate } from '../Services/translation';
import { load } from '../Actions/GenericExport.action';
import constants from '../constants';

class ExportMenuContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { ...props };
    }

    componentDidMount() {
        if (!this.props || !this.props.exportMenu) {
            return;
        }
    }
    componentDidUpdate() {
        const { exportMenu } = this.props;
        if (!exportMenu.errors) {
            return;
        }
    }

    toggle() {
        var $el = document.getElementById('genericExport');
        if ($el) {
            if ($el.className.indexOf('hide') !== -1) {
                $el.classList.remove('generic-export__container--hide');
            }
            if (constants.dataSource === 'MyPages') {
                this.props.load();
            }
        }
        else {
            this.setState({ exportMenu: { ...this.props.exportMenu, showInfo: true } });
        }
    }

    render() {
        if (this.props.mobile) {
            return (
                <Fragment>
                    <div className="navbar__link export-wrapper" onClick={() => this.toggle()}>{translate('common.exportmenu.title')}</div>
                    {this.state.exportMenu.showInfo &&
                        <section className="generic-export">
                            <div id="genericExport" className="generic-export__container" data-areatype="ProductArea">
                                <GenericExportContainer />
                        </div>
                    </section>}
                </Fragment>
            )
        }
        else {
            return (
                <Fragment>
                    <span className="top-link__title" onClick={() => this.toggle()}>{translate('common.exportmenu.title')}</span>
                    {this.state.exportMenu.showInfo &&
                        <section className="generic-export">
                        <div id="genericExport" className="generic-export__container" data-areatype="ProductArea">
                            <GenericExportContainer />
                        </div>
                        </section>}
                </Fragment>
            )
        }
    }
}

const mapStateToProps = state => {
    const { exportMenu } = state;
    return {
        exportMenu
    }
}

const mapDispatchToProps = dispatch => {
    return {
        load: () => dispatch(load()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExportMenuContainer);